import React, { useContext } from "react";
import PropTypes from "prop-types";
import { MobileContext } from "components/common";
import errorIcon from "assets/error-icon.svg";
import List from "./List";

const ListItem = ({
  element,
  showRelink,
  handleRelink,
  decorator,
  disabled
}) => (
  <div className={`flex ${showRelink ? "justify-between" : ""}`}>
    <span className={`self-start ${disabled ? "text-gray-400" : ""}`}>
      {`${element.institution} - ${element.nickname} (**${element.account_number_last_four})`}
    </span>
    {!showRelink && (
      <i
        className={`fa fa-check-circle ml-4 text-xl ${
          disabled ? "text-gray-400" : "text-green-primary"
        }`}
      />
    )}
    {showRelink && (
      <span
        className="ml-4 self-end flex items-center cursor-pointer"
        onClick={e => {
          handleRelink(element.id);
          e.stopPropagation();
          e.preventDefault();
          return false;
        }}
      >
        <div className="shadow-xl bg-red-400 hover:bg-red-500 rounded text-sm font-medium text-white px-2 py-1">
          <div className="px-2 flex">
            <img src={errorIcon} className="" alt="Error Icon" />
            <span className="ml-2">Re-link</span>
          </div>
        </div>
      </span>
    )}
    {decorator && decorator()}
  </div>
);

const MiniPaymentMethodsList = ({
  paymentMethods = [],
  didSelect,
  handleRemove,
  handleRelink,
  className,
  disabled,
  // allowRemoveForIds = [],
  ...rest
}) => {
  // const { isMobile } = useContext(MobileContext);
  return (
    <List
      elements={paymentMethods}
      component={element => (
        <ListItem
          {...element}
          key={element.element.id}
          allowRemove={false}
          showRelink={element.element.unlinked}
          handleRelink={() =>
            handleRelink(element.element.relink_id, element.element.aggregator)
          }
        />
      )}
      didSelect={didSelect}
      className={className}
      disabled={disabled}
      {...rest}
    />
  );
};

MiniPaymentMethodsList.propTypes = {
  paymentMethods: PropTypes.array.isRequired,
  didSelect: PropTypes.func,
  handleRemove: PropTypes.func,
  handleRelink: PropTypes.func,
  disabled: PropTypes.bool,
  allowRemoveForIds: PropTypes.array
};

MiniPaymentMethodsList.defaultProps = {
  didSelect: () => {},
  handleRemove: () => {},
  handleRelink: () => {},
  disabled: false
};

export default MiniPaymentMethodsList;
